import packageJson from '../../../../package.json';

export const APP_FRONT_VERSION = packageJson.version;
